let _localizationService: any = null;

export const setLocalizationService = (service: any) => {
  _localizationService = service;
};

export const getLocalizationService = () => {
  return _localizationService;
};